import React from "react";
import { useBusinessStatus } from "@/context/BusinessStatusContext";

const STYLES = {
  open: { dot: "bg-emerald-400", ring: "border-emerald-500/40 bg-emerald-950/40 text-emerald-300", pulse: true },
  closing_soon: { dot: "bg-amber-400", ring: "border-amber-500/40 bg-amber-950/30 text-amber-300", pulse: true },
  closed: { dot: "bg-red-500", ring: "border-red-600/40 bg-red-950/30 text-red-300", pulse: false },
};

export function BusinessStatusBadge({ variant = "compact" }) {
  const { status } = useBusinessStatus();
  if (!status) return null;
  const st = STYLES[status.status] || STYLES.closed;

  if (variant === "banner") {
    return (
      <div data-testid="business-status-banner" className={`inline-flex items-center gap-3 rounded-full border px-5 py-2.5 ${st.ring}`}>
        <span className="relative flex h-3 w-3">
          {st.pulse && <span className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-60 ${st.dot}`} />}
          <span className={`relative inline-flex rounded-full h-3 w-3 ${st.dot}`} />
        </span>
        <span className="font-display font-black uppercase tracking-wide text-sm">{status.label}</span>
        <span className="text-sm opacity-80">{status.message}</span>
      </div>
    );
  }

  return (
    <div data-testid="business-status-badge" title={status.message} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 ${st.ring}`}>
      <span className="relative flex h-2 w-2">
        {st.pulse && <span className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-60 ${st.dot}`} />}
        <span className={`relative inline-flex rounded-full h-2 w-2 ${st.dot}`} />
      </span>
      <span className="font-display font-black uppercase tracking-wide text-[11px] leading-none">{status.label}</span>
    </div>
  );
}
